import { render, staticRenderFns } from "./Clubs.vue?vue&type=template&id=6d34b9c2&scoped=true&"
import script from "./Clubs.vue?vue&type=script&lang=js&"
export * from "./Clubs.vue?vue&type=script&lang=js&"
import style0 from "./Clubs.vue?vue&type=style&index=0&id=6d34b9c2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d34b9c2",
  null
  
)

export default component.exports